<template>
    <div class="wrapper tab-go-medicus">
        <header>
            <span class="new-headline-lg text-centered">Kein Rezept? Kein Problem.</span>
        </header>

        <div class="onboarding-card">
            <div class="onboarding-card-body">
                <strong class="new-text-xl">Lassen Sie sich Vitadio bequem online verschreiben.</strong>

                <p class="new-text-lg text-color-default">Vereinbaren Sie eine Videosprechstunde bei GoMedicus. Neben einer möglichen Verschreibung von Vitadio können Sie auch Fragen zu Diabetes besprechen.</p>

                <v-button :href="goMedicusUrl" target="_blank" label="Termin buchen"></v-button>

                <ul class="benefit-list no-list-style">
                    <li v-for="item in benefits" :key="item" class="new-text-lg">
                        <span class="benefit-list-icon" v-html="checkIcon"></span>
                        <span>{{ item }}</span>
                    </li>
                </ul>
            </div>

            <figure class="onboarding-card-image">
                <img src="imgs/web/img_quiz_form.svg" alt="">
            </figure>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            checkIcon: "<svg width=\"21\" height=\"21\" viewBox=\"0 0 20.54 20.54\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <circle cx=\"10.2667\" cy=\"10.2667\" r=\"10.2667\" fill=\"#A7EFD1\"/> <path d=\"M8.82166 12.1886L14.1118 6.9624L14.8145 7.65358L8.82166 13.5465L6.03571 10.8079L6.71521 10.1167L8.82166 12.1886Z\" fill=\"#00A671\"/> </svg>",
            goMedicusUrl: 'https://gomedicus.de/booking-referral?ref=Z29tLXJsOmU1NzY3YjlhLTg4NzQtNDdkNC1hZGMyLTc5N2E5ODhlYWIzZA',
            benefits: ['Kostenlos', 'Bequem online', 'Persönliche Beratung']
        }
    }
}
</script>
